// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"46975a64","498":"a9552f09","703":"5d3ae1e5"}[chunkId] + ".chunk.js";
};